<template>
    <div class="card-data sm" :class="isActive()" @click="$emit('changeRange', initRange, endRange, passersByBarChart, visitorsBarChart)">
        <Tooltip 
            :tip="tip"
            :tooltipActive="tooltipActive"
        />
        <div class="card-title">
            <h5 class="title">{{title}}</h5>
            <small v-if="initRangeTitle == endRangeTitle">{{initRangeTitle}}</small>
            <small v-else>del {{initRangeTitle}} al {{endRangeTitle}}</small>
        </div>
        <div v-if="!loader">
            <Loader/>
        </div>
            <EmptyStateChart v-else-if="captureRate!=captureRate"
            :title="titleEmpty"
            :caption="captionEmpty"
            />
        <div v-else class="card-infra">
            <div style="display: inline-block; text-align: center; width: 33.3334%">
                <ICountUp
                    :endVal="captureRate"
                    :options="percentageOptions"
                    class="infra-data"
                    />
                <p class="infra-group">Capture rate</p>
            </div>
            <div style="display: inline-block; text-align: center; width: 33.3334%">
                <ICountUp
                    :endVal="totalVisitors"
                    :options="options(completeVisitors)"
                    class="infra-data"
                    />
                <p class="infra-group">Visitantes</p>
            </div>
            <div style="display: inline-block; text-align: center; width: 33.3334%">
                <ICountUp
                    :endVal="totalPassersBy"
                    :options="options(completePasserby)"
                    class="infra-data"
                    />
                <p class="infra-group">Transeúntes</p>
            </div>
        </div>
        
    </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'

import ICountUp from 'vue-countup-v2'
import Loader from '@/components/Loader'
import Tooltip from '@/components/Tooltip'
import EmptyStateChart from '@/components/EmptyStateChart'

import { mapActions } from 'vuex'

export default {
    name: 'AmountInfraCard',
    components: {
        ICountUp,
        Loader,
        Tooltip,
        EmptyStateChart
    },
    props: {
        title: {
            type: String,
            required: true
        },
        endRange: {
            required: true
        },
        initRange: {
            required: true
        },
        store_id: {
            required: true
        },
        selectedRange: {
            required: true
        },
        tip: {
            type: String,
            required: true
        },
        md: {
            type: Boolean,
            required: false
        },
        captionEmpty:{
            type: String,
            default: "Puedes consultar la vista de los últimos 7 o 30 días.",
        },
        titleEmpty: {
            type: String,
            default: "Este gráfico no esta disponible para esta vista"
        }
    },
    data: function(){
        return {
            totalPassersBy: 0,
            totalVisitors: 0,
            previous: 0,
            loader: false,
            completePasserby: 0,
            completeVisitors: 0,
            passersByBarChart: {},
            visitorsBarChart: {},
            percentageOptions: {
                duration: 0.6,
                useEasing: true,
                useGrouping: true,
                decimalPlaces: 1,
                separator: '.',
                decimal:',',
                prefix:'',
                suffix:' %'
            }
        }
    },
    computed: {
        initRangeTitle: function(){
            var dateStr = this.initRange.split("-")
            let monthNames = [
                                "Ene", "Feb", "Mar",
                                "Abr", "May", "Jun", "Jul",
                                "Ago", "Sep", "Oct",
                                "Nov", "Dic"
                            ]              
            return dateStr[2]+" de "+monthNames[this.initRange.split('-')[1] - 1];
        },
        endRangeTitle: function(){
            var dateStr = this.endRange.split("-")
            let monthNames = [
                                "Ene", "Feb", "Mar",
                                "Abr", "May", "Jun", "Jul",
                                "Ago", "Sep", "Oct",
                                "Nov", "Dic"
                            ]
            return dateStr[2]+" de "+monthNames[this.endRange.split('-')[1] - 1];
        },
        captureRate: function(){
            return (this.completeVisitors * 100) / (this.completePasserby + this.completeVisitors)
        }
    },
    methods: {
        isActive: function(){
            if(this.selectedRange==this.initRange){
                this.tooltipActive = true
                return 'active'
            }else{
                this.tooltipActive = false
                return ''
            }
        },
        showPassersBy: function(){
            this.loader = false
            let headers = {
                'Authorization': 'ZGFuaWVsQGZyZWRlc0BlbHVuOm51YmU1NDMyMTBuMHVzM3N3MW5kMHJ6'
            }
            axios.get(process.env.VUE_APP_ANALYTICS_HOST+"/api/passer_by/?init_date="+this.initRange+"&end_date="+this.endRange+"&store_id="+this.store_id, {
                headers: headers
            })
                .then((res) => {
                    let sumConnection = 0;
                    if(this.initRange != this.endRange){
                        // eslint-disable-next-line no-undef
                        _.each(res.data, (value) => {
                            sumConnection = sumConnection + value.value
                        })
                        this.completePasserby = sumConnection
                        this.totalPassersBy = sumConnection
                    }
                    else if(this.initRange == this.endRange){
                        let last7days = moment().subtract(7,'d').format('YYYY-MM-DD')
                        let yesterday = moment().subtract(1, 'd').format('YYYY-MM-DD')
                        let headers = {
                            'Authorization': 'ZGFuaWVsQGZyZWRlc0BlbHVuOm51YmU1NDMyMTBuMHVzM3N3MW5kMHJ6'
                        }
                        axios.get(process.env.VUE_APP_ANALYTICS_HOST+"/api/passer_by/?init_date="+last7days+"&end_date="+yesterday+"&store_id="+this.store_id, {
                            headers: headers
                        })
                            .then((resp) =>{
                                let totalConectrionsinADay = resp.data[resp.data.length - 1].value
                                this.completePasserby = totalConectrionsinADay
                                this.totalPassersBy = totalConectrionsinADay
                            })
                            .catch(() => {
                                this.loader =  true;
                                this.totalPassersBy = null
                            })
                    }
                    this.passersByBarChart = res.data
                    if (this.totalPassersBy > 999999) {
                        this.totalPassersBy = this.totalPassersBy / 1000000
                    }
                    this.showVisitors()
                    this.loader = true
                })
                .catch(() => {
                    this.loader =  true;
                    this.totalPassersBy = null
                })
        },
        showVisitors: function(){
            if (this.initRange == moment().subtract(29, 'd').format('YYYY-MM-DD')){
                this.changeMaxRange(true)
            } else {
                this.changeMaxRange(false)
            }
            let headers = {
                'Authorization': 'ZGFuaWVsQGZyZWRlc0BlbHVuOm51YmU1NDMyMTBuMHVzM3N3MW5kMHJ6'
            }
            axios.get(process.env.VUE_APP_ANALYTICS_HOST+"/api/visitors/?init_date="+this.initRange+"&end_date="+this.endRange+"&store_id="+this.store_id, {
                headers: headers
            })
                .then((res) => {
                    let sumConnection = 0;
                    if(this.initRange != this.endRange){
                        // eslint-disable-next-line no-undef
                        _.each(res.data, (value) => {
                            sumConnection = sumConnection + value.value
                        })
                        this.completeVisitors = sumConnection
                        this.totalVisitors = sumConnection
                    }
                    else if(this.initRange == this.endRange){
                        let last7days = moment().subtract(7,'d').format('YYYY-MM-DD')
                        let yesterday = moment().subtract(1, 'd').format('YYYY-MM-DD')
                        let headers = {
                            'Authorization': 'ZGFuaWVsQGZyZWRlc0BlbHVuOm51YmU1NDMyMTBuMHVzM3N3MW5kMHJ6'
                        }
                        axios.get(process.env.VUE_APP_ANALYTICS_HOST+"/api/visitors/?init_date="+last7days+"&end_date="+yesterday+"&store_id="+this.store_id, {
                            headers: headers
                        })
                            .then((resp) =>{
                                let totalConectrionsinADay = resp.data[resp.data.length - 1].value
                                this.completeVisitors = totalConectrionsinADay
                                this.totalVisitors = totalConectrionsinADay
                            })
                            .catch(() => {
                                this.loader =  true;
                                this.totalPassersBy = null
                            })
                    }
                    this.visitorsBarChart = res.data
                    if (this.totalVisitors > 999999) {
                        this.totalVisitors = this.totalVisitors / 1000000
                    }
                    this.loader = true
                    if (this.initRange == this.selectedRange) {
                        this.$emit('changeRange', this.initRange, this.endRange, this.passersByBarChart, this.visitorsBarChart)
                    }
                    this.loader = true
                })
                .catch(() => {
                    this.loader = true;
                    this.totalVisitors = null

                })
        },
        ...mapActions('auth', [
            'changeMaxRange'
        ]),
        options: function(num){
            if (num > 999999) {
                return {
                    useEasing: true,
                    useGrouping: true,
                    duration: 0.6,
                    separator: '.',
                    decimal: ',',
                    decimalPlaces: 1,
                    prefix:'',
                    suffix:' MM'
                }
            }

            return {
                useEasing: true,
                useGrouping: true,
                duration: 0.6,
                separator: '.',
                decimal:',',
                prefix:'',
                suffix:''
            }

        }
    },
    mounted: function(){
        this.showPassersBy()
    },
    watch: {
        store_id: function() {
            this.showPassersBy()
        }
    },
    
}
</script>

<style lang="sass">
.card-data .actual 
    font-family: $title-font
    font-size: 40px
    font-weight: 600
    text-align: right
    color: $dark
    @include mobile
        font-size: 28px


.card-data .infra-data 
    display: inline-block
    margin-bottom: 2px
.infra-data
    font-size: 24px
    @include mobile
        font-size: 20px
    @include tablet-landscape
        font-size: 20px
    @include tablet-portrait
        font-size: 16px
.card-data .infra-group 
    font-family: $body-font
    font-size: 12px
    font-weight: 300
    text-align: center
    color: $dark


.card-infra 
    margin-bottom: 16px
    margin-top: 8px
    font-family: $title-font
    font-size: 24px
    font-weight: 600
    color: $dark
    display: flex
    align-items: center
    @include mobile
        margin-top: $md
    @include tablet-portrait
        font-size: 16px

</style>